import { logDataToConsole, logError } from "../utils/customLogger";

type Store = Record<string, unknown>;

class UserGeneralInfoStore {
  private static instance: UserGeneralInfoStore;
  private store: Store = {};

  private constructor() {}

  static getInstance(): UserGeneralInfoStore {
    if (!UserGeneralInfoStore.instance) {
      UserGeneralInfoStore.instance = new UserGeneralInfoStore();
    }
    return UserGeneralInfoStore.instance;
  }

  getItem(key: string): unknown {
    try {
      return this.store[key] ?? null;
    } catch (error) {
      logError(error as Error, "Error getting item from store");
      return null;
    }
  }

  setItem(key: string, value: unknown): void {
    try {
      this.store[key] = value;
    } catch (error) {
      logError(error as Error, "Error setting item in store");
    }
  }

  removeItem(key: string): void {
    try {
      delete this.store[key];
    } catch (error) {
      logError(error as Error, "Error removing item from store");
    }
  }

  clearAll(): void {
    try {
      this.store = {};
    } catch (error) {
      logError(error as Error, "Error clearing store");
    }
  }

  containsItem(key: string): boolean {
    try {
      return key in this.store;
    } catch (error) {
      logError(error as Error, "Error checking item in store");
      return false;
    }
  }

  updateItem(key: string, newValue: unknown): void {
    try {
      const existingItem = this.store[key];
      if (existingItem !== undefined) {
        this.store[key] = { ...(existingItem as Record<string, unknown>), ...(newValue as Record<string, unknown>) };
      } else {
        logDataToConsole(`Item with key "${key}" does not exist in store.`);
      }
    } catch (error) {
      logError(error as Error, "Error updating item in store");
    }
  }

  getAllItems(): Store {
    try {
      return { ...this.store };
    } catch (error) {
      logError(error as Error, "Error getting all items from store");
      return {};
    }
  }

  getStoreLength(): number {
    try {
      return Object.keys(this.store).length;
    } catch (error) {
      logError(error as Error, "Error getting store length");
      return 0;
    }
  }
}

export const UserStore = UserGeneralInfoStore.getInstance();

export enum UserGeneralInfoContextKeys {
  VIEW_LEGACY = "viewLegacy",
  USER_ID = "userId",
  HEALTHCARE_FACILITY_ID = "healthcareFacilityId",
  INTERNAL_ORGANIZATION_FACILITY_ID = "internalOrganizationFacilityId",
  PARENT_TABLE = "parentTable",
  BO_COMMENTS = "boComments",
  JCODE_DOCS = "jCodeDocs",
  GLOBAL_BO_VALUE = "globalBoValue",
  AUTH_STATUS_CHANGE_COMMENTS = "authStatusChangeComments",
  CPT_CODES = "cptCodes",
  J_CODES = "jCodes",
  EXISTING_JCODE_DOCS = "existingJCodeDocs",
  MEDICINE_NAMES = "medicineNames",
  INDEX_TAB = "indexTab",
  PAYER_NAME = "payerName",
  ENABLE_REVIEW_MODE = "enableReviewMode",
}
